import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const ExpandIcon = ({ expanded } : any) => (
    <img
      src={ "/images/icon-add.png"}
      alt={expanded ? "Collapse" : "Expand"}
      width={25}
      height={25}
      style={{
        transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
        transition: 'transform 0.3s ease-in-out',
      }}
    />
  );

export const DataContent = [
  {
    title: "How much commission can I earn with the partner program?",
    content: (
      <Typography component="div" className='accordion-content'>
        <p>As a partner, you can start earning commissions for every qualified residential electricity enrollment made through your unique referral link or code. A referral is considered "qualified" once the customer's service begins and the enrollment passes supplier verification checks.</p>
      </Typography>
    )
  },
  {
    title: "When and how will I receive my commission payments?",
    content: (
      <Typography component="div" className='accordion-content'>
        <p>Commission payments are typically processed within a few weeks after your referral's service start date, provided the enrollment is valid and active. Payments are generally issued via ACH transfer to the banking information you provide during onboarding.</p>
      </Typography>
    )
  },
  {
    title: "Who can become a partner?",
    content: (
      <Typography component="div" className='accordion-content'>
        <p>Anyone passionate about helping people save on their electricity bills can apply — whether you're:</p>
        <ul>
          <li>An influencer or content creator</li>
          <li>A community leader or service provider</li>
          <li>A side hustler looking to earn extra income</li>
          <li>A local business or non-profit</li>
          <li>Etc.</li>
        </ul>
        <p>Approval may depend on basic identity verification and compliance with our referral guidelines.</p>
      </Typography>
    )
  },
  {
    title: "How are my referrals tracked?",
    content: (
      <Typography component="div" className='accordion-content'>
        <p>Each partner receives a unique referral link or code. When a customer enrolls using your link:</p>
        <ul>
          <li>The enrollment is automatically attributed to you</li>
          <li>You can track performance and payouts via your partner portal</li>
        </ul>
        <p>Our system maintains internal logs to ensure fair tracking and accurate reporting.</p>
      </Typography>
    )
  }
];

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: 'none',
  // borderBottom: `1px solid ${theme.palette.divider}`,
  marginBottom:'30px',
  padding: '10px 20px',
  '&:before': {
    display: 'none',
  }
}));

const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: theme.spacing(2, 0),
  minHeight: 'auto',
  '& .MuiAccordionSummary-content': {
    margin: 0,
    '&.Mui-expanded': {
      margin: 0,
    }
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.primary.main,
    '&.Mui-expanded': {
      transform: 'rotate(45deg) !important',
    }
  }
}));

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0, 0, 2),
  display: 'block',
  '& p': {
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.6,
    color:'#333333',
    fontSize:'16px'
  },
  '& ul': {
    paddingLeft: theme.spacing(2),
    margin: theme.spacing(1, 0, 1.5),
    '& li': {
      marginBottom: theme.spacing(1),
      lineHeight: 1.6,
    }
  }
}));

export default function FAQAccordion() {
  return (
    <div>
      {DataContent.map((item, index) => (
        <StyledAccordion key={index}>
          <StyledAccordionSummary
            expandIcon={<ExpandIcon />}
            aria-controls={`panel${index+1}a-content`}
            id={`panel${index+1}a-header`}
          >
            <Typography variant="h6" className='accordion-title'>
              {item.title}
            </Typography>
          </StyledAccordionSummary>
          <StyledAccordionDetails>
            {item.content}
          </StyledAccordionDetails>
        </StyledAccordion>
      ))}
    </div>
  );
}